import {Directive, ElementRef, HostListener, Input} from "@angular/core";
import {PrintPreviewService} from "./print-preview.service";
import {defaultPopupOptions, PopupOptions} from "../misc/dom-helper";

@Directive({
  selector: "[printOnClick]",
})
export class PrintOnClickDirective {
  @Input("printOnClick")
  key: string;

  @Input("windowTitle")
  title: string = "Print";

  @Input("showImmediately")
  showPrintDialogImmediately: boolean = true;

  @Input("windowOptions")
  options: PopupOptions = defaultPopupOptions;

  constructor(private elementRef: ElementRef, private printPreviewService: PrintPreviewService) {}

  @HostListener("click")
  click() {
    let element;

    if (this.key) {
      element = this.printPreviewService.getPrintableByKey(this.key);
    } else {
      element = this.printPreviewService.getNearbyPrintable(this.elementRef.nativeElement);
    }

    if (!element) {
      throw new Error("Could not find matching printable item!");
    }

    this.printPreviewService.printPreview(element, this.title, this.showPrintDialogImmediately, this.options)
      .catch((error) => { console.error(error); });
  }
}
